// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1eWew","label":"SetPasswdForm_label__1nYOF"};